<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "AuthorName",
  extends: UrlElement,
  elementPanelSettings: {
    elementGroup: "storyElements",
    elementType: "element",
    displayName: "Author Name",
    displayIcon: "text-alt",
  },
  mixins: [StoryPageElementMixin],
  computed: {
    label() {
      return this.entity.authoringName;
    },
    computedHref() {
      return `${this.links.web}/user-profile/${this.entity.authoringUserId}`;
    },
  },
};
</script>
